import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserManageInfo } from './../models/userManageInfo';
import { LoaderService } from './../services/loader.service';

@Injectable()
export class AuthService {

  public UserConnected = new BehaviorSubject<UserManageInfo>(null);

  constructor(private httpClient: HttpClient, private router: Router, private loaderService: LoaderService) {

  }

  private getCustomHeaders(): any {
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'bearer ' + this.getToken() });
  }

  private getCustomHeadersWithImplantId(idImpianto: number): any {
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'bearer ' + this.getToken(), 'idImpianto': idImpianto.toString() });
  }

  setToken(token: string) {
    localStorage.setItem("accessToken", token);
  }

  getToken(): string {
    return localStorage.getItem("accessToken");
  }

  setIdImpianto(idImpianto: string) {
    localStorage.setItem("idImpianto", idImpianto);
  }

  getIdImpianto(): string {
    return localStorage.getItem("idImpianto");
  }

  logout() {
    //api/Account/Logout        

    //let options = { headers: new HttpHeaders() };
    //options.headers = this.getCustomHeaders(null);
    const headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', 'bearer ' + this.getToken());
    localStorage.removeItem("accessToken");
    if (localStorage.getItem("idImpianto") != null)
      localStorage.removeItem("idImpianto");

    return this.httpClient
      .post('api/account/logout', {}, { headers: headers })
      .catch((error: Response) => {
        if (error.status == 401)
          return this.router.navigate(['auth/login']);
        return Observable.throw(error)
      })
      .map((response: any) => {
        this.router.navigate(['auth/login']);
        this.UserConnected.next(null);
        return true;
      });
  }

  login(username: string, password: string, OTP: string) {


    const headers = this.getCustomHeaders();

    const body = new HttpParams()
      .set('username', username)
      .set('password', password)
      .set('OTP', OTP)
      .set('grant_type', 'password');
    
    this.loaderService.showSpinner();

    return this.httpClient
      .post('token', body, { headers: headers })
      .catch((error: Response) => Observable.throw(error))
      .map((response: any) => {
        this.setToken(response.access_token);
        return response;
      })
      .finally(() => {
        this.loaderService.hideSpinner();
      });
  }

  getManageInfo(idImpianto?: number): Observable<UserManageInfo> {

    if (idImpianto == null) {
      var idImpiantoTemp = this.getIdImpianto();
      if (idImpiantoTemp != null) {
        idImpianto = Number(this.getIdImpianto());
      }
    }

    var header = idImpianto != null ? this.getCustomHeadersWithImplantId(idImpianto) : this.getCustomHeaders();

    return this.httpClient.get('api/Account/ManageInfo', { headers: header })
      .catch((error: Response) => {
        if (error.status == 401)
          return this.logout();
        return Observable.throw(error)
      })
      .map((response: UserManageInfo) => {
        if (response.IdImpianto != null) {
          this.setIdImpianto(response.IdImpianto.toString());
        }
        return response;
      }).do(response => this.UserConnected.next(response));

  }

  putChangePasswordCurrentUser(oldPassword: string, newPassword: string, confirmPassword: string): Observable<boolean> {
    var Form: any = {};
    Form.NewPassword = newPassword;
    Form.OldPassword = oldPassword;
    Form.ConfirmPassword = confirmPassword;
    return this.httpClient.put('api/account/changepassword', Form, { headers: this.getCustomHeaders() })
      .catch((error: any) => { console.log("putChangePassword: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  postForgotPassword(email: string) {
    var Form: any = { Email: email };
    return this.httpClient.post('api/account/forgotpassword', Form, { headers: this.getCustomHeaders() })
      .catch((error: any) => { console.log("postForgotPassword: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  postResetPassword(email: string, password: string, token: string) {
    var Form: any = { Email: email, Token: token, Password: password };

    return this.httpClient.post('api/account/resetpassword', Form, { headers: this.getCustomHeaders() })
      .catch((error: any) => { console.log("postResetPassword: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return true;
      });
  }

  setTwoFactorsAuthentication(OTP: string, key: string) {
    var Form: any = { OTP: OTP, Key: key };

    return this.httpClient.put('api/account/SetTwoFactorsAuth', Form, { headers: this.getCustomHeaders() })
      .catch((error: any) => { console.log("setTwoFactorsAuthentication: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }

  getTwoFactorsAuthentication() {
    return this.httpClient.get('api/account/GetTwoFactorsAuth', { headers: this.getCustomHeaders() })
      .catch((error: any) => { console.log("getTwoFactorsAuthentication: ", error); return Observable.throw(error); })
      .map((response: any) => {
        return response;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts